import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import React, { useState, useEffect, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import apiHelper from "../../util/ApiHelper";
import { useLoading } from "../../util/LoadingProvider";

const useStyles = makeStyles({
  root: {
    marginBottom: "40px",
  },
  button: {
    backgroundColor: "#306F9D",
    textTransform: "capitalize",
    color: "white",
    "&:hover": {
      backgroundColor: "#306F9D",
    },
  },
});

function ProfilePage(props) {
  const {
    control,
    handleSubmit,
    watch,
    getValues,
  } = useForm();
  const classes = useStyles();
  const [adminInfo, setAdminInfo] = useState(
    JSON.parse(sessionStorage.getItem("adminInfo"))
  );
  const password = useRef(null);
  password.current = watch("password", "");

  const { setLoading } = useLoading();

  const getAdminInfo = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.adminInfo();
      console.log("result:", result);
      sessionStorage.setItem("adminInfo", JSON.stringify(result.data));
      setAdminInfo(result.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAdminInfo();
  }, []);

  const onSubmit = async (values) => {
    setLoading(true);
    const params = values.password
      ? values
      : { email: values.email, username: values.username, role: values.role };
    console.log(params);
    try {
      const result = await apiHelper.cinefan.updateAdminInfo(params);
      console.log(result.data);

      toast.dark("Your changes is saved.");
      sessionStorage.removeItem("adminInfo");
      getAdminInfo();
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    adminInfo && (
      <div>
        <Grid container xs={12} md={8}>
          <form onSubmit={handleSubmit(onSubmit)} style={{ width: "80%" }}>
            <Typography variant="h4" gutterBottom>
              Profile
            </Typography>
            <Typography variant="h6" gutterBottom>
              Manage Profile Settings
            </Typography>
            <Box display="flex" flexDirection="column" className={classes.root}>
              <Controller
                name="email"
                control={control}
                defaultValue={adminInfo.email}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    margin="dense"
                    variant="outlined"
                    error={!!error}
                    disabled
                    helperText={
                      error
                        ? error.message
                        : "This email is used for log in and contact"
                    }
                    {...field}
                  />
                )}
                rules={{ required: "Email required" }}
              />
              <Controller
                name="username"
                control={control}
                defaultValue={adminInfo.username}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    margin="dense"
                    variant="outlined"
                    error={!!error}
                    helperText={
                      error ? error.message : "This name is used for display"
                    }
                    {...field}
                  />
                )}
                rules={{ required: "Name required" }}
              />
              <Controller
                name="password"
                control={control}
                defaultValue=""
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    margin="dense"
                    label="Enter New Password"
                    variant="outlined"
                    type="password"
                    error={!!error}
                    helperText={
                      error
                        ? error.message
                        : "Leave it blank if you don’t want to change your password"
                    }
                    {...field}
                  />
                )}
              />
              <Controller
                name="rePassword"
                control={control}
                defaultValue=""
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    margin="dense"
                    label="Re-enter New Password"
                    variant="outlined"
                    type="password"
                    error={!!error}
                    helperText={
                      error ? error.message : "Enter your new password again"
                    }
                    {...field}
                  />
                )}
                rules={{
                  validate: (value) => {
                    const newPassword = getValues("password");
                    if (
                      (newPassword !== "" || value !== "") &&
                      value !== newPassword
                    ) {
                      return "The passwords do not match";
                    }
                  },
                }}
              />
              <Controller
                name="role"
                control={control}
                disabled
                defaultValue={adminInfo.role}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    margin="dense"
                    variant="outlined"
                    error={!!error}
                    disabled
                    helperText={
                      error
                        ? error.message
                        : "Roles can only be edited by the Administrator"
                    }
                    {...field}
                  />
                )}
              />
            </Box>
            <Grid xs={6} md={4} lg={4}>
              <Button
                className={classes.button}
                type="submit"
                variant="contained"
                color="primary"
              >
                Save Changes
              </Button>
            </Grid>
          </form>
        </Grid>
      </div>
    )
  );
}

export default ProfilePage;
